import { baseApi as api } from 'shared/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		withdrawalRequestList: build.query<WithdrawalRequestListApiResponse, WithdrawalRequestListApiArg>({
			query: (queryArg) => ({
				url: `/api/withdrawal_request/`,
				params: {
					created_after: queryArg.createdAfter,
					created_before: queryArg.createdBefore,
					limit: queryArg.limit,
					offset: queryArg.offset,
					ordering: queryArg.ordering,
				},
			}),
		}),
		withdrawalRequestCreate: build.mutation<WithdrawalRequestCreateApiResponse, WithdrawalRequestCreateApiArg>({
			query: () => ({ url: `/api/withdrawal_request/`, method: 'POST' }),
		}),
		withdrawalRequestRetrieve: build.query<WithdrawalRequestRetrieveApiResponse, WithdrawalRequestRetrieveApiArg>({
			query: (queryArg) => ({ url: `/api/withdrawal_request/${queryArg}/` }),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type WithdrawalRequestListApiResponse = /** status 200  */ PaginatedWithdrawalRequestListRead;
export type WithdrawalRequestListApiArg = {
	createdAfter?: string;
	createdBefore?: string;
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	/** Which field to use when ordering the results. */
	ordering?: string;
};
export type WithdrawalRequestCreateApiResponse = /** status 201  */ WithdrawalRequestRead;
export type WithdrawalRequestCreateApiArg = void;
export type WithdrawalRequestRetrieveApiResponse = /** status 200  */ WithdrawalRequestRead;
export type WithdrawalRequestRetrieveApiArg = /** A UUID string identifying this transaction request. */ string;
export type WithdrawalRequest = {};
export type WithdrawalRequestRead = {
	uuid: string;
	created_at: string;
	amount: string;
	status: WithdrawalRequestStatusEnum;
	payment_system_account_url: string | null;
};
export type PaginatedWithdrawalRequestList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: WithdrawalRequest[];
};
export type PaginatedWithdrawalRequestListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: WithdrawalRequestRead[];
};
export enum WithdrawalRequestStatusEnum {
	InProgress = 'in_progress',
	Success = 'success',
	Failed = 'failed',
}
